<ng-content>
    @if(iconClass) {
        <span [class]="iconClass"></span>
    }

    @if (label) {
        <span class="font-bold white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ label }}</span>
    }

    @if(iconClassAfter) {
        <span [class]="iconClassAfter"></span>
    }
</ng-content>